import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import PortalVue from 'portal-vue'
import LogStatsd from '@/js/perf/log-statsd.js'

import LogEvents from '@/js/log-events.js'
import APIRequest from '@/js/api-request.js'
import Analytics from '@/js/analytics/index.js'

Vue.use(VueCookie)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(PortalVue)

Analytics.initialize()
Vue.use(Analytics)

Vue.use(APIRequest)
Vue.use(LogEvents)
Vue.use(LogStatsd)
